import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Auth0Provider } from '@auth0/auth0-react';
import { MyProvider } from "./context/DataContext";
import reportWebVitals from "./reportWebVitals";
import { getErrorMessage } from "./utils/errorHandling";

const root = ReactDOM.createRoot(document.getElementById("root")!);

window.addEventListener("unhandledrejection", (event) => {
    console.error(`Unhandled promise rejection: ${getErrorMessage(event.reason)}`, event.reason);
    event.preventDefault();
});

root.render(
    <BrowserRouter>
        <Auth0Provider
            domain="auth.datapebbles.com"
            clientId="aerb8GwRYajCDSdYQPG5swn1mbuBdFUV"
            authorizationParams={{
                redirect_uri: window.location.origin,
                audience: "auth-service"
            }}
            cacheLocation='localstorage'
        >
            <React.StrictMode>
                <MyProvider>
                    <App />
                </MyProvider>
            </React.StrictMode>
        </Auth0Provider>
    </BrowserRouter>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
